import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';

export const FETCH_SPARKICCIDAUDITLOG_REQUEST = 'FETCH_SPARKICCIDAUDITLOG_REQUEST';
export const FETCH_SPARKICCIDAUDITLOG_SUCCESS = 'FETCH_SPARKICCIDAUDITLOG_SUCCESS';
export const FETCH_SPARKICCIDAUDITLOG_ERROR = 'FETCH_SPARKICCIDAUDITLOG_ERROR';

const GET_SPARKICCIDAUDITLOG_DETAIL_REQUEST = 'GET_SPARKICCIDAUDITLOG_DETAIL_REQUEST';
const GET_SPARKICCIDAUDITLOG_DETAIL_SUCCESS = 'GET_SPARKICCIDAUDITLOG_DETAIL_SUCCESS';
const GET_SPARKICCIDAUDITLOG_DETAIL_ERROR = 'GET_SPARKICCIDAUDITLOG_DETAIL_ERROR';

export const CREATE_SPARKICCIDAUDITLOG_REQUEST = 'CREATE_SPARKICCIDAUDITLOG_REQUEST';
export const CREATE_SPARKICCIDAUDITLOG_SUCCESS = 'CREATE_SPARKICCIDAUDITLOG_SUCCESS';
export const CREATE_SPARKICCIDAUDITLOG_ERROR = 'CREATE_SPARKICCIDAUDITLOG_ERROR';

export const UPDATE_SPARKICCIDAUDITLOG_REQUEST = 'UPDATE_SPARKICCIDAUDITLOG_REQUEST';
export const UPDATE_SPARKICCIDAUDITLOG_SUCCESS = 'UPDATE_SPARKICCIDAUDITLOG_SUCCESS';
export const UPDATE_SPARKICCIDAUDITLOG_ERROR = 'UPDATE_SPARKICCIDAUDITLOG_ERROR';

export const DELETE_SPARKICCIDAUDITLOG_REQUEST = 'DELETE_SPARKICCIDAUDITLOG_REQUEST';
export const DELETE_SPARKICCIDAUDITLOG_SUCCESS = 'DELETE_SPARKICCIDAUDITLOG_SUCCESS';
export const DELETE_SPARKICCIDAUDITLOG_ERROR = 'DELETE_SPARKICCIDAUDITLOG_ERROR';

export const CHECK_SPARKICCIDAUDITLOG_AVAILABILITY_REQUEST = 'CHECK_SPARKICCIDAUDITLOG_AVAILABILITY_REQUEST';
export const CHECK_SPARKICCIDAUDITLOG_AVAILABILITY_SUCCESS = 'CHECK_SPARKICCIDAUDITLOG_AVAILABILITY_SUCCESS';
export const CHECK_SPARKICCIDAUDITLOG_AVAILABILITY_ERROR = 'CHECK_SPARKICCIDAUDITLOG_AVAILABILITY_ERROR';

const baseUrl = 'payment/SparkIccidAuditLog/';

export const fetchSparkIccidAuditLog = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_SPARKICCIDAUDITLOG_REQUEST,
        FETCH_SPARKICCIDAUDITLOG_SUCCESS,
        FETCH_SPARKICCIDAUDITLOG_ERROR,
      ],
      callAPI: () => ApiClient.post(baseUrl + 'Search', data),
      payload: { data },
    }),
  );
};

export const getSparkIccidAuditLogDetail = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GET_SPARKICCIDAUDITLOG_DETAIL_REQUEST,
        GET_SPARKICCIDAUDITLOG_DETAIL_SUCCESS,
        GET_SPARKICCIDAUDITLOG_DETAIL_ERROR,
      ],
      callAPI: () => ApiClient.get(baseUrl + `${id}`),
      payload: { data: { id } },
    }),
  );
};

export const createSparkIccidAuditLog = (data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [CREATE_SPARKICCIDAUDITLOG_REQUEST, CREATE_SPARKICCIDAUDITLOG_SUCCESS, CREATE_SPARKICCIDAUDITLOG_ERROR],
      callAPI: () => ApiClient.post(baseUrl, data),
      payload: { data, formId },
    }),
  );
};

export const updateSparkIccidAuditLog = (id, data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [UPDATE_SPARKICCIDAUDITLOG_REQUEST, UPDATE_SPARKICCIDAUDITLOG_SUCCESS, UPDATE_SPARKICCIDAUDITLOG_ERROR],
      callAPI: () => ApiClient.put(baseUrl + `${id}`, data),
      payload: { data: { ...data, id }, formId },
    }),
  );
};

export const deleteSparkIccidAuditLog = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [DELETE_SPARKICCIDAUDITLOG_REQUEST, DELETE_SPARKICCIDAUDITLOG_SUCCESS, DELETE_SPARKICCIDAUDITLOG_ERROR],
      callAPI: () => ApiClient.delete(baseUrl + `${id}`),
      payload: { data: { id } },
    }),
  );
};

export const checkSparkIccidAvailability = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        CHECK_SPARKICCIDAUDITLOG_AVAILABILITY_REQUEST,
        CHECK_SPARKICCIDAUDITLOG_AVAILABILITY_SUCCESS,
        CHECK_SPARKICCIDAUDITLOG_AVAILABILITY_ERROR,
      ],
      callAPI: () => ApiClient.post(baseUrl + `CheckAvailability/${id}`),
      payload: { data: { id } },
    }),
  );
};

const initialState = {
    payload: {},
    data: {},
    response: {},
    error: {},
    errorMessage: '',
    successMessage: '',
};

export default function reducer(state = initialState, action) {
  const { payload, response, error, successMessage, errorMessage } = action;
  switch (action.type) {
    case FETCH_SPARKICCIDAUDITLOG_REQUEST:
    case GET_SPARKICCIDAUDITLOG_DETAIL_REQUEST:
    case CREATE_SPARKICCIDAUDITLOG_REQUEST:
    case UPDATE_SPARKICCIDAUDITLOG_REQUEST:
    case DELETE_SPARKICCIDAUDITLOG_REQUEST:
    case CHECK_SPARKICCIDAUDITLOG_AVAILABILITY_REQUEST:
      return {
        ...state,
        payload,
        response: {},
        error: {},
        successMessage: '',
        errorMessage: '',
      };

    case FETCH_SPARKICCIDAUDITLOG_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          items: response.data.data.items,
          pages: response.data.data.pageCount,
        },
        response,
        successMessage,
      };

    case GET_SPARKICCIDAUDITLOG_DETAIL_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          item: response.data.data,
        },
        response,
        successMessage,
      };
    case CREATE_SPARKICCIDAUDITLOG_SUCCESS:
    case UPDATE_SPARKICCIDAUDITLOG_SUCCESS:
    case DELETE_SPARKICCIDAUDITLOG_SUCCESS:
    case CHECK_SPARKICCIDAUDITLOG_AVAILABILITY_SUCCESS:
      return {
        ...state,
        response,
        successMessage,
      };
      
    case FETCH_SPARKICCIDAUDITLOG_ERROR:
    case GET_SPARKICCIDAUDITLOG_DETAIL_ERROR:
    case CREATE_SPARKICCIDAUDITLOG_ERROR:
    case UPDATE_SPARKICCIDAUDITLOG_ERROR:
    case DELETE_SPARKICCIDAUDITLOG_ERROR:
    case CHECK_SPARKICCIDAUDITLOG_AVAILABILITY_ERROR:
      return {
        ...state,
        payload,
        error,
        errorMessage,
      };
    default:
      return state;
  }
}
